import React from 'react'

const Stars = ({n}) => {
    
    return (
        <div className="movie__stars">
            <i className={`fa fa-star ${n>=1 ? 'ylw' : ''}`} aria-hidden="true"></i>
            <i className={`fa fa-star ${n>=2 ? 'ylw' : ''}`} aria-hidden="true"></i>
            <i className={`fa fa-star ${n>=3 ? 'ylw' : ''}`} aria-hidden="true"></i>
            <i className={`fa fa-star ${n>=4 ? 'ylw' : ''}`} aria-hidden="true"></i>
            <i className={`fa fa-star ${n>=5 ? 'ylw' : ''}`} aria-hidden="true"></i>
        </div>
    )
}

export default Stars
